export default __webpack_public_path__ + "static/media/345D.9a0786de.pdf";